import * as React from 'react';
import { ChromePicker } from 'react-color';
import { Collapse, Label } from 'reactstrap';
import ColorBall from '../../../../components/ColorBall';
import { NumberInputField, SelectTextField, TextInputField } from '../../../../components/Forms/fields';
import { Marker, markerToString, parseMarker } from '../../../../shared/marker';
import './MarkerForm.scss';

export interface MarkerFormProps {
    id: string,
    value?: string,
    onChange: (value: string) => void,
}

const defaultMarker: Marker = {
    name: 'Marker',
    size: 30,
    symbol: '◯',
    color: '#F00',
}

const availableMarkers: string[] = Array.from("✓○◯◌◍●◐◑◒◓✪❂⚉⦸⦵⦻⨂⨁⦾⦿⨀☢☣◠◡□▢■✪★☆✰✬✦✧🟌✶✷✸✹⁕❆꙰✣✤✺✻✳✴❇▲△▶▷▼▽◀◁◢◣◤◥◬◭◮◸◹◺◿⛛⟁⧊⧋⧌⧎⧏⧐⧨⧩⨹⨺⨻►◄➣➤➥➦⇦⇧⇨⇩⇳⬆↗➡↘⬇↙⬅↖↕↔↩↪⤴⤵↚↛↜↢↣↫↬↝↜↭⟿↮↯↶↷↹↺↻⟲⟳⇄⇇⇈⇉⇊⇐⇑⇒⇓⇔⇕⇖⇗⇘⇙⇚⇛⇠⇡⇢⇣⤌⤍⤎⤏☼☀☁🌤🌧🌨🌩🌪☂☃🌡⭕✔❌🔴🟠🟡🟢🔵🟣🟤⚫⚪🟥🟧🟨🟩🟦🟪🟫⬛⬜🔶🔷🔺🔻💠〽❓❗〰➰➿⭐🌟🔙🔚🔛🔜🔝🔀🔁🔃⛅💪🦵🦶👂👃🧠🦷🦴👀👄👅");

const MarkerForm: React.FC<MarkerFormProps> = ({
    id,
    value: valueStr,
    onChange,
}) => {

    const [showColorPicker, setShowColorPiker] = React.useState<boolean>(false);

    const value = React.useMemo<Marker>(() => valueStr && parseMarker(valueStr) || defaultMarker, [valueStr]);
    const setValue = React.useCallback((value: Marker) => onChange(markerToString(value)), [onChange]);

    React.useEffect(() => {
        if(valueStr == 'new') onChange(markerToString(value));
    }, [valueStr])

    return (
        <div className='markerForm'>
            <Label style={{fontSize: `${value.size}px`, color: value.color}}>{value.symbol}</Label>
            <div className='fieldsContainer'>
                <TextInputField 
                    id={`${id}-name`}
                    value={value.name}
                    onChange={name => setValue({...value, name})}/>
                <span className='markerFormRow'>
                    <SelectTextField 
                        id={`${id}-symbol`}
                        className='imageMarkerInput'
                        options={availableMarkers}
                        value={value.symbol}
                        onValueChanged={symbol => setValue({...value, symbol})}/>
                    <NumberInputField 
                        id={`${id}-size`}
                        value={value.size}
                        onChange={(size = 0) => setValue({...value, size})}/>
                    <ColorBall id={`${id}-show-color`} color={value.color} onClick={() => setShowColorPiker(!showColorPicker)}/>
                </span>
                <Collapse id={`${id}-color`} isOpen={showColorPicker}>
                    <ChromePicker 
                        color={value.color}
                        onChange={color => setValue({...value, color: color.hex})}/>
                </Collapse>
            </div>
        </div>
    );
}

export default MarkerForm;